define('models/search/searchresult_collection',[
    'backbone',
    'models/search/searchitem'
], function(Backbone, SearchItem){

    var SearchList = Backbone.Collection.extend({
        url: function(){
            if (this.instanceURL){
                return this.instanceURL;
            } else {
                return pf.searchURL;
            }
        },
        model   : SearchItem,
        defaults: {
            pageSize: 30
        },
        state: {
            order      : 1,
            sortKey    : 'Name',
            pageSize   : 30,
            lastPage   : null,
            firstPage  : 1,
            currentPage: null
        },
        queryParams: {
            totalPages  : null,
            totalRecords: null
        },
        initialize: function(options){
            options = options || {};
            if(options.pageSize > 0){
                this.pageSize = parseInt(options.pageSize);
            } else {
                this.pageSize = 30;
            }
            this.LocationTypeID = options.LTID;
            this.instanceURL = options.instanceURL;
        },
        parseState: function(resp, queryParams, state, options){
            return { currentPage: resp.currentPage, totalRecords: resp.total_count };
        },
        parse: function(resp, options){

            if(resp){

                this.currentPage = resp.currentPage;
            
                //if (this.currentPage == 1)
                //    this.totalRecords = resp.total_count;
                //this.totalPages = this.totalRecords / this.pageSize;
                if(resp.items){
                    return resp.items;
                } else {
                    return resp;
                }

            } else {

                return [];

            }

        }
    });
    return SearchList;
});

